module.exports = __webpack_public_path__ + "media/application/images/logo-black-background-9f97e31a190cd021ead6215fffbb75a9.svg";